import Image from '../index'
import React from 'react'

export default props => <Image
  { ...props }
  width={ 996 }
  sources={ [{
    renditions: [{ width: 996 }],
    media: '(min-width: 996px)',
  }, {
    renditions: [{ width: 750 }],
    media: '(min-width: 480px) and (max-width: 996px)',
  }, {
    renditions: [{ width: 480 }],
    media: '(max-width: 480px)',
  }] }
/>
